import './ItemResult.scss'

import React from 'react'
import { Link } from 'react-router-dom'

import { CoreURLs } from 'hb4e-ui-core'

import { getProductDetailsForListItem } from '../../../../../list-service'
import ListItemProductDetails from '../../../ListItemProductDetails/ListItemProductDetails'
import { urlListView } from '../../../../../urls'

const { urlIDPProduct } = CoreURLs

const ItemResult = ({ item }) => {
  const { productAuthors, productAvailabilityID, productImage, productTitle, productType, signpost } =
    getProductDetailsForListItem(item)

  const productURL = urlIDPProduct(productAvailabilityID, {})

  return (
    <div className="item-result">
      <div className="item-result__container">
        <img className="item-result__product-image" src={productImage} alt="" />

        <div className="item-result__product-info">
          <div className="item-result__product-type">
            <span className="item-result__product-type-category">{productType}</span>
            {signpost && <span className="item-result__product-type-signpost">{signpost}</span>}
          </div>
          <h3 className="item-result__product-title">
            <Link className="item-result__product-title-text" to={productURL}>
              {productTitle}
            </Link>
          </h3>
          <div className="item-result__product-authors">{`By: ${productAuthors}`}</div>

          <div className="item-result__product-details">
            <ListItemProductDetails item={item} />
          </div>
        </div>

        <div className="item-result__found-in">
          <div className="item-result__found-in-label">Found In Lists:</div>
          <ul>
            {item.featuredIn.map((list) => (
              <li className="item-result__found-in-list-item" key={list.getID()}>
                <Link className="item-result__found-in-list-item-link" to={urlListView(list.getID())}>
                  {list.getName()}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default ItemResult
